/** Barre de progression — CSS only, animée. */
type ProgressBarProps = {
  value: number;
  tone?: "accent" | "muted" | "warn";
  label?: string;
};

export function ProgressBar({ value, tone = "accent", label }: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div
      className={`fx-pbar fx-pbar--${tone}`}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(pct)}
      aria-label={label}
    >
      <span style={{ ["--p" as string]: `${pct}%` }} />
    </div>
  );
}
